class VwOrganizasyonYetkiDTO {
    id: number = null;
    fkOrganizasyon?: number = null;
    kullaniciId?: number = null;
    eklemeTarihi?: string = null;
    ekleyenKullanici?: number = null;
    treekey?: string = "";
    organizasyon?: string = "";
    bagliId?: number = null;
    aktif?: string = "";
    seviye?: number = null;
    kurumId?: number = null;
    kurumTarifeId?: number = null;
    disBarkodVar?: string = "";
    tip?: number = null;
    videoUrl?: string = "";
    hastaborckontrol?: string = "";
    disbarkodkaraktersayisi?: number = null;
    sadeceKendiHastalari?: string = "H";
    farkliparabirimleriodemeaktif?: string = "";
    parabirimiGoster?: string = "";
    kurGoster?: string = "";
    roundyuvarlama?: number = null;
    birimTreekey?: string = "";
    calisanBilgileri?: number = 1;
    bagliOrgParabirim?: string = "E";
    tipId?: number = null;
    icmalParaBirimId?: number = 1;
    //View Dışı
    yetkili: string = "H";
}
export default VwOrganizasyonYetkiDTO;